/**
 * Formats a Kubernetes UTC timestamp to the user's local timezone.
 * Returns empty string if the input is falsy.
 */
export const formatTimestamp = (timestamp?: string): string => {
  if (!timestamp) return '';
  return new Date(timestamp).toLocaleString();
};
